import React, { useState, useRef, useEffect, useContext } from "react";
import Header from "Components/Header";
import Footer from "Components/Footer";
import styled from "styled-components";
import Bg from "Images/CorrectorRegister_bg.jpg";
import BgM from "Images/CorrectorRegister_bg_mo.jpg";
import Title from "Images/CorrectorRegister_title.png";
import Spinner from "Components/Spinner";
import { Color } from "Styles/Theme";
import { RiMailCheckLine } from "react-icons/ri";
import AuthContext from "Context/Auth/AuthContext";
import { fixoApi } from "Api";
import { device } from "Styles/Media";

const CorrectorRegister = ({ history: { push } }) => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [correctorMail, setCorrectorMail] = useState("");
  const node = useRef();
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;

  const modalOn = () => {
    window.alert("정식 버전에서 뵙겠습니다.");
    // if (!isAuthenticated) {
    //   window.alert("로그인이 필요합니다");
    //   push("/login");
    //   return;
    // }
    // setModal(true);
  };

  const emailValue = (e) => {
    setCorrectorMail(e.target.value);
  };

  const modalOff = (e) => {
    if (!node.current.contains(e.target)) {
      setModal(false);
      setCorrectorMail("");
      return;
    }
  };

  const emailSandButton = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await fixoApi.correctorEmailSand(correctorMail);
      if (res.data.message === "EMAIL SENT") {
        setModal(false);
        setCorrectorMail("");
      }
    } catch (error) {
      console.log(error);
      let errorMessage = error.response.data.message;
      if (errorMessage === "NOT COMPANY EMAIL ADDRESS") {
        alert("회사 메일이 아니므로 인증메일 발송이 불가능합니다.");
      } else if (errorMessage === "INVALID EMAIL") {
        alert("이메일 형식이 바르지 않습니다");
      } else {
        alert("로그인이 필요합니다");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", modalOff);
    return () => {
      document.removeEventListener("mousedown", modalOff);
    };
  }, []);

  return (
    <Container>
      <Header />
      <Content>
        <ContentText>
          <img src={Title} alt="이메일 인증 한번이면 끝나는 등록" />
          <p>*추가 인증이 필요할 수 있습니다</p>
          <Button onClick={modalOn}>첨삭자 등록하기</Button>
        </ContentText>
        <EmailModal toggle={modal}>
          <form ref={node}>
            <p>
              <RiMailCheckLine />
              이메일을 입력해주세요
            </p>
            <input
              type="email"
              value={correctorMail}
              onChange={emailValue}
              placeholder="회사메일만 입력 가능합니다."
            />
            <div>
              <SubmitButton onClick={emailSandButton}>
                첨삭자 등록하기
              </SubmitButton>
              {loading && (
                <Loader>
                  <Spinner fontSize="4px" />
                </Loader>
              )}
            </div>
          </form>
        </EmailModal>
      </Content>
      <Footer />
    </Container>
  );
};

export default CorrectorRegister;

const Container = styled.section`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 340px);
  min-height: 500px;
  background: url(${Bg}) no-repeat center center;
  background-attachment: fixed;
  background-size: cover;
  background-color: #babbbc;
  @media ${device.tablet} {
    background: url(${BgM}) no-repeat center center;
    background-size: cover;
  }
`;

const ContentText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-15%, -50%);
  text-align: center;
  @media ${device.tablet} {
    transform: translate(-50%, -80%);
  }
  img {
    height: 110px;
    @media ${device.tablet} {
      height: 100px;
    }
    @media ${device.mobile} {
      height: 85px;
    }
  }
  p {
    margin: 25px 0 35px;
    color: #717171;
    font-size: 15px;
    @media ${device.tablet} {
      margin: 20px 0 25px;
      font-size: 14px;
    }
    @media ${device.mobile} {
      margin: 15px 0 20px;
      font-size: 14px;
    }
  }
`;

const EmailModal = styled.div`
  display: ${(props) => (props.toggle ? "block" : "none")};
  position: fixed;
  background-color: #000000c4;
  z-index: 99;
  margin-top: -90px;
  width: 100vw;
  height: 100vh;
  cursor: zoom-out;
  form {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 400px;
    border-radius: 10px;
    padding: 50px;
    background-color: #fff;
    cursor: default;
    p {
      display: flex;
      justify-content: center;
      font-size: 18px;
      svg {
        color: ${Color.purple};
        margin-right: 5px;
      }
    }
    input {
      width: 300px;
      height: 55px;
      padding: 10px 20px;
      margin: 30px 0 10px;
      border: 1px solid #b3b3b3;
      border-radius: 10px;
      font-size: 17px;
      color: #515151;
      &:focus {
        outline: none;
        border: 1px solid #7903d4;
        box-shadow: 3px 4px 9px #b7b7b7;
      }
    }
    input::placeholder {
      color: #b3b3b3;
      font-size: 15px;
    }
    & > div {
      position: relative;
    }
  }
`;

const Button = styled.button`
  width: 190px;
  height: 60px;
  font-size: 16px;
  border: 0;
  border-radius: 10px;
  background-color: ${Color.purple};
  transition: all 0.4s ease 0s;
  color: #fff;
  cursor: pointer;
  outline: none;
  @media ${device.tablet} {
    border: 1px solid #fff;
  }
`;

const SubmitButton = styled(Button)`
  width: 300px;
  height: 55px;
  font-size: 16px;
  position: relative;
  &:hover {
    color: ${Color.purple};
    background: #fff;
    font-weight: 900;
    border: 2px solid;
    border-color: ${Color.purple};
    transition: all 0.4s ease 0s;
  }
  &:focus {
    outline: none;
  }
`;

const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: ${Color.purple};
`;
